var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTauxCompletionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7011_8042)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7011_8042)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(2.5 2.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7229 20.0273V25.2524C22.7229 25.4024 22.6229 25.5024 22.4729 25.5024H10.7969C10.6469 25.5024 10.5469 25.4024 10.5469 25.2524C10.5469 25.1274 10.6469 25.0024 10.7969 25.0024H14.7222V22.7274C14.7222 22.5774 14.8472 22.4774 14.9723 22.4774H18.9726V20.0273C18.9726 19.9023 19.0976 19.7773 19.2226 19.7773H22.4729C22.5979 19.7773 22.7229 19.8773 22.7229 20.0273Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9766 16.9492V19.2742H20.4766V17.0742L20.9766 16.9492Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.352 10.3V13.45C25.352 13.55 25.302 13.625 25.202 13.675C25.127 13.725 25.002 13.7 24.952 13.65C23.7518 12.725 22.4517 14.525 20.9766 13.9V14.475C20.9016 14.475 20.8266 14.45 20.7766 14.45C20.6766 14.45 20.5766 14.45 20.4766 14.5V9.75C20.4766 9.625 20.6016 9.5 20.7266 9.5C20.8766 9.5 20.9766 9.625 20.9766 9.75V10.175C21.5517 10.55 22.1517 10.325 22.8268 10.075C23.5768 9.775 24.4269 9.45 25.252 10.125C25.302 10.15 25.352 10.225 25.352 10.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 12.4023C13.0781 11.5773 13.7532 10.9023 14.5783 10.9023C15.4033 10.9023 16.0784 11.5773 16.0784 12.4023C16.0784 13.2274 15.4033 13.9024 14.5783 13.9024C13.7532 13.9024 13.0781 13.2274 13.0781 12.4023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9985 16.425L18.3983 17.1C17.8732 17.275 17.2482 17.2 16.7731 16.85L16.023 16.325L15.973 18.275L17.2982 18.6C17.9232 18.75 18.3983 19.275 18.4983 19.875C18.4733 20 18.4983 19.925 18.4733 21.95H16.6981V20.775C16.6981 20.625 16.5981 20.5 16.4481 20.45L14.923 20.125C14.8479 20.575 15.173 18.55 14.2479 24.4V24.475H12.4477C12.4227 24.4 12.4227 24.325 12.4477 24.25L12.9728 19.1C12.8728 18.9 12.8228 18.7 12.8228 18.475V16.3L11.7977 17.425C11.7977 17.425 11.7727 17.45 11.7727 17.475L11.2476 19.175C11.1476 19.5 10.8476 19.725 10.4976 19.75C9.92252 19.75 9.54749 19.225 9.6725 18.725L10.0975 17.05C10.1225 16.95 10.1725 16.875 10.2225 16.8L12.0977 14.6C12.3977 14.25 12.8228 14.075 13.2728 14.1L15.698 14.25C16.4231 14.3 16.6981 14.775 17.5482 15.4C17.7732 15.575 18.0482 15.625 18.3232 15.525L20.5734 14.975C20.9735 14.85 21.4485 15.1 21.5235 15.575C21.5735 15.95 21.3485 16.3 20.9985 16.425Z",
    fill: "black"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 34.5,
    height: 34.5,
    stroke: "#E6E6E7",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7011_8042",
    x: 0.5,
    y: 2.5,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7011_8042"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.627451 0 0 0 0 0.698039 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7011_8042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7011_8042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7011_8042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTauxCompletionIcon);
export default __webpack_public_path__ + "static/media/tauxCompletionIcon.f4a1ddcf78e409a2559e2b7a41901f78.svg";
export { ForwardRef as ReactComponent };